import { HelpCircle } from 'lucide-react';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';
import type { PKGNodeComponentProps } from './DecisionNode.tsx';

// Renders any entity_type outside the 6 named components (issue,
// adr_label, risk_label, issue_label) so the canvas never crashes on a
// real /related response. See recon §1.5, adjudication Q2, safeguard S1.
export function FallbackNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-fallback"
      shape="square-outline"
      accentColor={colors.semantic.muted}
      icon={HelpCircle}
      label={data.summary ?? data.entityId}
      badge={data.badge ?? data.entityType}
      outlineOnly
      isConnectable={isConnectable}
    />
  );
}
